
import TeacherInfoService from "@/api/teacherService";
let teacherInfo = {};
let teacherMineList = {};
let curKlassId = "";

try {
	curKlassId = localStorage.getItem("curKlassId") || "";
	teacherInfo = JSON.parse(localStorage.getItem("teacherInfo")) || {};
	teacherMineList = JSON.parse(localStorage.getItem("teacherMineList")) || [];
} catch (err) {
	console.log("err====>", err)
}

const state = {
	teacherInfo,
	curKlassId,
	teacherMineList,
};

const getters = {
	teacherInfo: state => state.teacherInfo,
	curKlassId: state => state.curKlassId,
	teacherMineList: state => state.teacherMineList,
	curKlassTeacher: ({ teacherInfo, curKlassId }) => {
		const teachers = teacherInfo.teachers || [];
		if (!curKlassId) {
			return teachers[0];
		}
		return teachers.find(item => item.klass && item.klass.id === curKlassId) || {};
	},
	klassInfo: ({ teacherInfo, curKlassId }) => {
		const teachers = teacherInfo.teachers || [];
		if (!teachers.length) return {};
		const curKlassTeacher = teachers.find(item => item.klass && item.klass.id === curKlassId) || teachers[0] || {};
		return curKlassTeacher.klass || {};
	},

	schoolInfo: ({ teacherInfo, curKlassId }) => {
		const teachers = teacherInfo.teachers || [];
		if (!teachers.length) return { id: teacherInfo.school_id };
		const curKlassTeacher = teachers.find(item => item.klass && item.klass.id === curKlassId) || teachers[0] || {};
		return curKlassTeacher.school || { id: teacherInfo.school_id };
	},

	roleInfo: ({ teacherInfo, curKlassId }) => {
		const teachers = teacherInfo.teachers || [];
		if (!teachers.length) return {};
		const curKlassTeacher = teachers.find(item => item.klass && item.klass.id === curKlassId) || teachers[0] || {};
		return curKlassTeacher.role;
	},

	isManager: ({ teacherInfo }) => {
		if (!teacherInfo.teachers || !teacherInfo.teachers.length) {
			return false;
		}

		const activeTeacher = teacherInfo.teachers.filter(item => item.is_active) || [];
		if (!activeTeacher.length) {
			return false;
		}

		if (activeTeacher.find(item => item.role.permission === "MANAGER")) {
			return true;
		}

		return false;

		// if (!curKlassId) {
		// 	return activeTeacher[0].role.permission === "MANAGER";
		// }

		// const curKlass = activeTeacher.find(item => item.klass.id === curKlassId) || { role: {} };
		// return curKlass.role.permission === "MANAGER";
	},

	isTeacher: ({ teacherInfo, curKlassId }) => {
		if (!curKlassId || !teacherInfo.teachers || !teacherInfo.teachers.length) {
			return false;
		}
		const activeTeacher = teacherInfo.teachers.filter(item => item.is_active && item.klass) || [];
		if (!activeTeacher.length) {
			return false;
		}

		const curKlass = activeTeacher.find(item => item.klass.id === curKlassId) || { role: {} };
		return curKlass.role.permission === "TEACHER";
	},

	hasTeacherRole: ({ teacherInfo }) => {
		const teachers = teacherInfo.teachers || [];
		const activeTeacher = teachers.filter(item => item.is_active && item.klass) || [];
		return activeTeacher.length > 0
	}
};

const actions = {
	getTeacherInfoMineListService({ commit }, data) {
		return new Promise((resolve, reject) => {
			TeacherInfoService.getTeacherInfoMineListService(data).then((res = []) => {
				const activeTeacherList = res.filter(item => item.is_active);
				commit("setTeacherMine", activeTeacherList[0]);
				commit("setTeacherMineList", activeTeacherList);
				resolve(activeTeacherList);
			}).catch((err) => {
				reject(err);
			});
		});
	},
	getTeacherInfoListService({ commit }, data) {
		return new Promise((resolve, reject) => {
			TeacherInfoService.getTeacherInfoMineListService(data).then((res) => {
				commit("setTeacherMineList", res);
				resolve(res);
			}).catch((err) => {
				reject(err);
			});
		});
	},
};

const mutations = {
	setTeacherMine(state, teacherInfo = {}) {
		localStorage.setItem("teacherInfo", JSON.stringify(teacherInfo));
		state.teacherInfo = teacherInfo;
		const teachers = teacherInfo.teachers || [];
		const activeTeacher = teachers.filter(item => item.is_active && item.klass) || [];
		if (!activeTeacher.length) {
			state.curKlassId = undefined;
			localStorage.setItem("curKlassId", "");
			return
		}

		if (!state.curKlassId || !activeTeacher.find(item => item.klass.id === state.curKlassId)) {
			state.curKlassId = activeTeacher[0].klass.id;
			localStorage.setItem("curKlassId", state.curKlassId);
		}

	},
	setTeacherMineList(state, teacherMineList = []) {
		localStorage.setItem("teacherMineList", JSON.stringify(teacherMineList));
		state.teacherMineList = teacherMineList;
	},
};

export default {
	actions,
	getters,
	state,
	mutations,
};
